<template>
	<div class="vote">
		<div class="vote__area" :class="{ interactive: showIdea }">
			<VoteArea
				ref="voteArea"
				:wall="wall"
				:idea="currentIdea"
				:submitting="submitting"
				@vote="onVote"
			/>
		</div>
		<div class="vote__ui" v-if="!hideUi">
			<VoteProgress />
			<VoteUI @vote="onUIVote" />
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import toast from '@/mixins/toast'
import VoteArea from '@/components/vote/VoteArea'
import VoteUI from '@/components/vote/VoteUI'
import VoteProgress from '@/components/vote/VoteProgress'

const INIT_MS = 400
const SUBMIT_MIN_MS = 1000

export default {
	name: 'Vote',
	props: {
		hideUi: {
			type: Boolean,
			default: false
		},
		wall: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			initTimeout: null,
			submitTimeout: null,
			showIdea: false,
			submitting: false
		}
	},
	computed: {
		...mapGetters({
			canVote: 'session/canVote',
			idea: 'session/currentSubmission'
		}),
		currentIdea() {
			return this.canVote && this.showIdea ? this.idea : null
		}
	},
	methods: {
		...mapActions('session', ['addVote', 'end']),
		onUIVote(liked) {
			// Votes from UI trigger a swipe in the vote area
			if (this.$refs.voteArea) this.$refs.voteArea.trigger(liked)
		},
		onVote(payload) {
			this.addVote(payload)
			if (!this.canVote) this.submitVotes()
		},
		async submitVotes() {
			this.submitting = true

			// Don't leave the submit screen too quickly!
			const end = this.end()
			const wait = new Promise(r => window.setTimeout(r, SUBMIT_MIN_MS))
			const [endResult] = await Promise.all([end, wait])

			if (endResult.success) {
				// Go to voted screen
				this.toast('Your votes were submitted successfully!')
				this.$emit('submitted', true)
			} else {
				// Return home
				this.toastErr(endResult.error)
				this.$emit('submitted', false)
			}
		}
	},
	mounted() {
		this.initTimeout = window.setTimeout(() => {
			this.showIdea = true
		}, INIT_MS)
	},
	beforeDestroy() {
		window.clearTimeout(this.initTimeout)
	},
	mixins: [toast],
	components: {
		VoteArea,
		VoteUI,
		VoteProgress
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/transitions';

@include fade(0.25s);

.vote {
	@extend %flex-col;
	flex-grow: 1;

	&__area {
		flex-grow: 1;
		position: relative;
		margin-top: -1rem;
		pointer-events: none;

		&.interactive {
			pointer-events: all;
		}
	}

	&__ui {
		flex-shrink: 0;
	}
}
</style>
